@if (!!language()) {
    <code-editor [indentWithTab]="true"
                 [languages]="[language()]"
                 [language]="language().name"
                 [placeholder]="placeholder()"
                 [extensions]="extensions()"
                 [disabled]="disabled()"
                 [value]="value()"
                 [theme]="theme()">
    </code-editor>
}